import { Box, ButtonBase, Typography } from "@mui/material";
import { Link } from "react-router-dom";

import styles from "../styles";

interface LeftSideBarIconProps {
  name: string | JSX.Element;
  icon: string;
  activeIcon: string;
  isActive: boolean;
  onClick: () => void;
  link?: string;
}

function LeftSideBarIcon({
  name,
  icon,
  activeIcon,
  isActive,
  onClick,
  link,
}: LeftSideBarIconProps) {
  const button = (
    <Box display="flex" flexDirection="column" alignItems="center">
      <ButtonBase
        sx={[isActive && styles.active, { width: "40px" }]}
        onClick={onClick}
      >
        <Box
          component="i"
          className={isActive ? activeIcon : icon}
          sx={styles.icon}
        />
      </ButtonBase>
      <Box sx={{ mt: -0.25, textAlign: "center" }}>
        <Typography variant="caption" sx={styles.iconText}>
          {name}
        </Typography>
      </Box>
    </Box>
  );

  if (!link) {
    return button;
  }

  return (
    <Box>
      <Link to={link} style={styles.link}>
        {button}
      </Link>
    </Box>
  );
}

export default LeftSideBarIcon;
